import { SvgIcon, SvgIconProps } from '@mui/material';

export const BarChart4Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 80 80">
    <svg width="80" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_3763_5656"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="80"
        height="80"
      >
        <rect width="80" height="80" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3763_5656)">
        <path
          d="M6.66675 70V63.3333H73.3334V70H6.66675ZM10.0001 60V36.6667H20.0001V60H10.0001ZM26.6667 60V20H36.6667V60H26.6667ZM43.3334 60V30H53.3334V60H43.3334ZM60.0001 60V10H70.0001V60H60.0001Z"
          fill="currentColor"
        />
      </g>
    </svg>
  </SvgIcon>
);

BarChart4Icon.muiName = 'BarChart4Icon';
